module.exports = __webpack_public_path__ + "static/img/index-right-radius_1.7de3a8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index-right-radius_1.png
// module id = wLQD
// module chunks = 0